<app-form-single-select
    [options]="products$ | async"
    [value]="productsCurrentValue$ | async"
    (valueChange)="productValueChange($event)"
    [placeholder]="'ci.common.products' | translate"
    [canClear]="false"
></app-form-single-select>